import { css, FlattenSimpleInterpolation, keyframes } from "styled-components";

export interface AppearFromBottomProps {
  index: number;
  isSectionVisible: boolean;
}

const getAppearFromBottomKeyframes = (translateFactor: number) => keyframes`
    0% {
      transform: translateY(${translateFactor * 50}%);
      opacity: 0;
    }
  
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  `;

export const getAnimationConfig = (
  index = 1,
  { columns } = { columns: 1 }
): FlattenSimpleInterpolation => css`
  animation: ${getAppearFromBottomKeyframes((index % columns) + 1)} 1.5s;
  animation-fill-mode: both;
  animation-delay: 0.5s;
`;
